import React from 'react';
import emoji from 'react-easy-emoji';

import './tweettext.scss';

const createTextArray = (text, displayLinks = true) => {
  // find anything starting with http/https and get all until a whitespace -> wrap in a link tag
  // if links should be displayed
  const replaceWith = displayLinks
    ? match => {
        return `<a class="tweet-link" href="${match}">${match}</a>`;
      }
    : '';

  const emojiedText = emoji(text, { props: { className: 'tweet-emoji' } });

  const html = emojiedText.map(i => {
    if (typeof i === 'string') {
      return i.replace(/:? ?(https?:\/\/\S+)/g, replaceWith);
    } else {
      return i;
    }
  });

  return html;
};

export default ({ text = '', displayLinks }) => {
  const fontSizeClass = text.length < 50 ? 'tweet-text--large' : '';
  const tweetText = createTextArray(text, displayLinks);

  return (
    <div className={`tweet-text ${fontSizeClass}`}>
      <div>
        {tweetText.map((t, i) => {
          if (typeof t === 'string') {
            return <span key={i} dangerouslySetInnerHTML={{ __html: t }}></span>;
          } else {
            return <span key={i}>{t}</span>;
          }
        })}
      </div>
    </div>
  );
};
